import { BillType } from '../../../../graphql/generated/graphql'

export enum LinkBill {
    SelectBillType,
    AddExistingBill,
    AddNewBill,
    LinkAccount,
}

export type BillSelect = {
    title: string
    secondaryLine: string
    merchantSearch: string
    icon?: JSX.Element
    type: BillType
}
